import { CSSObject } from "@emotion/react";
import { IonIcon } from "@ionic/react";
import { checkmark } from "ionicons/icons";

import {
  ModalSubFeedbackBody,
  ModalSubFeedbackFooter,
  ModalSubFeedbackHeader,
} from "~components/ModalSubFeedback/ModalSubFeedback";
import { translate } from "~utils";

type ModalSubFeedbackContentNeutralSummaryProps = {
  onDismiss: () => void;
};

const styles: Record<string, CSSObject> = {
  bodyContainer: {
    display: "flex",
    flex: 4,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 48,
    textAlign: "center",
  },
  ionIcon: {
    fontSize: 64,
    color: "green",
  },
};

export function ModalSubFeedbackContentNeutralSummary(
  props: ModalSubFeedbackContentNeutralSummaryProps,
) {
  const { onDismiss } = props;

  return (
    <>
      <ModalSubFeedbackHeader title={translate("FEEDBACK_SUBMITTED_LABEL")} onDismiss={onDismiss} />
      <ModalSubFeedbackBody>
        <div css={styles.bodyContainer}>
          <IonIcon slot="icon-only" icon={checkmark} css={styles.ionIcon} />
          <h3>{translate("MSF_SUMMARY_TITLE")}</h3>
          <p>{translate("MSF_NEUTRAL_SUMMARY_BODY")}</p>
        </div>
      </ModalSubFeedbackBody>
      <ModalSubFeedbackFooter
        buttonPrimary={{ onClick: onDismiss, isDisabled: false, text: "Close" }}
      />
    </>
  );
}
